import Immutable from 'immutable';

export const State = Immutable.fromJS({
	oldPassword: '',
  newPassword: '',
  confirmPassword: '',
  errMessage: '',
  isReset: false
});
